/**
 * We need this function to make sure we can set the BrPageModel type
 * because the toJSON function from the SDK has return type of "object".
 * This function will no longer be required when this is fixed in the SDK.
 */ function parsePageModel(page) {
    const pageModel = (page === null || page === void 0 ? void 0 : page.toJSON()) || {};
    return pageModel;
}

export { parsePageModel };
//# sourceMappingURL=parse-page-model.js.map
